<template>
  <DetailsPane :title="announcement.title" @close="$emit('close')">
    <div class="p-4" v-html="announcement.content"></div>
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
export default {
  components: { DetailsPane },
  props: {
    announcement: { type: Object, required: true }
  }
};
</script>